import {
	SET_COMMENTS,
	SET_COMMENT,
	CLEAR_COMMENTS,
	CLEAR_COMMENT,
	ADD_COMMENT,
	UPDATE_COMMENT,
	REMOVE_COMMENT,
} from './actionTypes';

export const comment = (state = {}, action) => {
	switch (action.type) {
		case SET_COMMENT:
			return action.payload;
		case UPDATE_COMMENT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_COMMENT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_COMMENTS:
			return action.payload;
		case ADD_COMMENT:
			return [...state, action.payload];
		case UPDATE_COMMENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_COMMENT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_COMMENTS:
			return [];
		default:
			return state;
	}
};
